export namespace ClientHooks {
    export async function init() {
        // Add content here
    }

    export async function preLogin() {
        // Add content here
    }

    export async function postLogin() {
        const {SurveyManagerApi} = await import('@/classes/api/survey-manager.api.class');
        await SurveyManagerApi.response.getAvailableSurveys();
    }

    export async function preLogout() {
        // Add content here
    }

    export async function postLogout() {
        // Add content here
    }
}
